import { loadModel } from '@/Engine/loader';
import { Mesh } from 'three';
import { $ } from '@/Engine/stateInstance';
import { xyz } from '@/Interfaces/common';

export async function loadDecorModel(decors: any) {
    for (const item of decors) {
        if ($.decorModels.get(item.url)) continue;
        const model = await loadModel(item.url) as Mesh;
        model.traverse((child)=>{
            child.castShadow = false;
            if (![ 'Mesh', 'Scene', 'Group' ].includes(child.type)) {
                child.visible = false;
            }
        });

        if (item.offsets) {
            model.position.set(...(JSON.parse(item.offsets) as xyz));
        }
        $.decorModels.set(item.url, { model, raw: item });
        if (!item.surfaces) return;
        item.surfaces.forEach((surface: { code: string; value: string })=>{
            const addedSurface = $.decorModelsBySurface.get(surface.code);
            if (!addedSurface)
                $.decorModelsBySurface.set(surface.code, [ { model, raw: item } ]);
            else
                addedSurface.push({ model, raw: item });
        });
        if ($.isDecoration) {
            $.wardrobe.addDecor($.decorModelsBySurface);
            $.render();
        }
    }
}
